import React from 'react';
import { isEmpty } from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './styles.scss';

export const SwitchTabs = ({ active, dataKey, list, wrapperClassName, onClick }) => {
  if (isEmpty(list)) {
    return null;
  }

  const key = dataKey || 'name';

  return (
    <div className={classnames('switch-tabs', wrapperClassName)}>
      {list.map((item, i) => (
        <div
          className={classnames('switch-tabs__item', { 'switch-tabs__item--active': item[key] === active })}
          key={i}
          onClick={() => onClick(item)}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

SwitchTabs.propTypes = {
  active: PropTypes.string,
  dataKey: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    }),
  ),
  onClick: PropTypes.func.isRequired,
  wrapperClassName: PropTypes.string,
};
